(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-card-list"] && !Shopify.designMode) return;
  try {
    
  const collectionCardList = document.querySelector('.collection-card-list-container');
  const cards = Array.from(collectionCardList.querySelectorAll('.collection-card'));
  for (const card of cards) {
    card.style.cursor = 'pointer';
    card.addEventListener("click", () => {
      let down, up, link = card.querySelector('a');
      card.onmousedown = () => down = +new Date();
      card.onmouseup = () => {
          up = +new Date();
          if ((up - down) < 200) {
              link.click();
          }
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
